import React, {useCallback, useEffect, useState} from 'react';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import localForage from 'localforage';
import fileDownload from 'js-file-download';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import api from 'services/Api';

export const store = localForage.createInstance({
  name: 'files',
});

window.addEventListener('beforeunload', () => {
  store.clear();
});

const downloadMap = new Map();

const Downloader = ({
  route,
  filename = null,
  cacheId = null,
  renderChildren = null,
  autoDownload = false,
}) => {
  const [downloading, setDownloading] = useState(autoDownload);
  const [progress, setProgress] = useState(0);
  const [objectURL, setObjectURL] = useState(null);

  const hasCustomChildren = !!renderChildren;

  const setData = useCallback(
    (data) => {
      if (data) {
        setProgress(100);
        setDownloading(false);
        if (hasCustomChildren) {
          setObjectURL(URL.createObjectURL(new Blob([data])));
        }
      }
    },
    [hasCustomChildren],
  );

  const isReactNativeWebView = () =>
    typeof window !== 'undefined' && window.ReactNativeWebView;

  const sendToRN = (data) => {
    if (isReactNativeWebView()) {
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  };

  const fullDownloadUrl = `https://api.pezeshket.com${route}`;

  const downloadFile = useCallback(async () => {
    console.log(filename, 'ffff');
    if (isReactNativeWebView() && filename) {
      const tokenObj = await api.getCachedToken();

      sendToRN({
        type: 'DOWNLOAD_FILE',
        url: fullDownloadUrl,
        token: tokenObj.access_token,
        filename,
      });
      return;
    }
    if (cacheId) {
      try {
        const data = await store.getItem(cacheId);
        if (data) {
          setData(data);
          if (filename) {
            fileDownload(data, filename);
          }
          return;
        }
      } catch (e) {
        console.error(e);
      }
    }

    try {
      setProgress(0);
      setDownloading(true);
      if (!downloadMap.has(route)) {
        const promise = api.invoke('GET', route, undefined, {
          api: {emitNotification: true},
          onDownloadProgress: (progressEvent) => {
            if (Math.floor(progressEvent.target.status / 100) === 2) {
              setProgress((progressEvent.loaded / progressEvent.total) * 100);
            }
          },
          responseType: 'arraybuffer',
        });

        downloadMap.set(route, promise);
      }

      const {data} = await downloadMap.get(route);
      setData(data);
      if (filename) {
        fileDownload(data, filename);
      }
      if (cacheId) {
        store.setItem(cacheId, data);
      }
    } finally {
      setDownloading(false);
      downloadMap.delete(route);
    }
  }, [cacheId, filename, route, setData]);

  useEffect(() => {
    const setFromCache = async () => {
      if (cacheId) {
        const data = await store.getItem(cacheId);
        setData(data);
      }
    };
    setFromCache();
  }, [cacheId, setData]);

  useEffect(() => {
    if (autoDownload) {
      downloadFile();
    }
  }, [autoDownload, downloadFile]);

  if (renderChildren) {
    return renderChildren({
      downloadFile,
      downloading,
      progress,
      filename,
      cacheId,
      objectURL,
    });
  }

  return (
    <IconButton
      edge="end"
      aria-label="download"
      onClick={downloadFile}
      disabled={downloading}
    >
      {downloading ? (
        <CircularProgress
          variant={progress ? 'static' : 'indeterminate'}
          value={progress}
          style={{direction: 'ltr'}}
          color="secondary"
        />
      ) : (
        <CloudDownloadIcon color="secondary" />
      )}
    </IconButton>
  );
};

export default Downloader;
